<template>
  <div class="pagemain">

    <div class="group_select" v-if="is_super_admin == 1">

      <Select clearable v-model="role_id" style="width: 170px" size="small" @on-change="role_change">
        <Option v-for="item in role_data_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </div>

    <!-- {{ bind_weixin_mp }}{{ bind_dingding }} -->

    <!-- <div class="page1">
      <div class="box_title1">
        <Icon type="ios-bookmark" color="#0466dd" size="20" />最近使用应用
        <div class="group_select" v-if="is_super_admin == 1">
      
          <Select
            clearable
            v-model="role_id"
            style="width: 170px"
            size="small"
            @on-change="role_change"
          >
            <Option
              v-for="item in role_data_list"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="child_btn-1">
        <div
          v-for="(item, i) in my_workbench_list"
          :key="i"
          class="menu_btn_my"
          @click="click_btn(item)"
        >
          <div class="menu_icon_box" :style="'background:' + item.icon_bg">
            <span
              :class="'menu_icon iconfont ' + item.icon"
              :style="'font-size:' + item.icon_size + 'px;'"
            ></span>
          </div>
          <div class="menu_btn_name">
            {{ item.name }}
          </div>
          <span
            v-if="!item.func_auth_status"
            class="iconfont iconlock_fill func_lock"
          ></span>
         
        </div>
      </div>
    </div> -->
    <!-- <div class="box_title_outer">
      <div class="box_title">
        <div class="quanbu_notif">
          <Icon type="ios-bookmark" color="#0466dd" size="20" />全部应用
          <div class="notification_div">
            <div class="notification-bar">
              <Icon type="md-volume-down" size="20" />
              <div v-for="(item, i) in notifications" :key="i">
                <div v-if="i == currentNotificationIndex">
                  【{{ item.type }}】{{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <span class="zhedie">
          <span v-if="total_show" @click="total_show = !total_show" class="zhedie_span">
            <Icon type="ios-arrow-dropup" />
            <span class="zhedie_txt">折叠</span>
          </span>

          <span v-else @click="total_show = !total_show" class="zhedie_span">
            <Icon type="ios-arrow-dropdown" />
            <span class="zhedie_txt">展开</span>
          </span>
        </span>
      </div>
    </div> -->

    <div v-if="workbench_total_list.length > 0" class="page12-1">
      <Spin fix v-if="total_menu_loading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        加载中...
      </Spin>
      <div v-if="total_show">
        <div v-for="(item, i) in workbench_total_list" :key="i">


          <div class="child_list">
            <div class="child_title" :style="'background:' + item.icon_bg">
              {{ item.name }}
            </div>
            <div class="child_btn">
              <div v-for="(item2, i2) in workbench_total_list[i]['child']" :key="i2" class="menu_btn"
                @click="click_btn(item2)">
                <div class="hot_div" v-if="item2.is_hot == 1">
                  <span class="iconfont iconhot menu_hot" title="热门应用"></span>
                </div>

                <div class="btn_right_icon">
                  <div class="collect_div">
                    <span @click.stop="click_shoucang(item2, 0)" class="iconfont iconshoucang"
                      v-if="item2.is_collect == 1"></span>
                    <span @click.stop="click_shoucang(item2, 1)" class="iconfont iconshoucang1"
                      v-if="item2.is_collect == 0"></span>
                  </div>
                </div>

                <div class="menu_icon_box" :style="'background:' + item2.icon_bg">
                  <span :class="'menu_icon iconfont ' + item2.icon"
                    :style="'font-size:' + item2.icon_size + 'px;'"></span>
                </div>
                <div class="menu_btn_name">
                  {{ item2.name }}
                </div>
                <span v-if="!item2.func_auth_status" class="iconfont iconlock_fill func_lock"></span>
                <!-- <div v-if="is_super_admin == 1" class="remove_btn">
                <Icon
                  type="ios-add-circle-outline"
                  @click.stop="add_menu(item2)"
                  class="add_menu_icon"
                />
              </div> -->
              </div>
            </div>
            <!-- <div v-for="(item2, i2) in workbench_total_list[i]['child']" :key="i2">
          {{ item2.name }}
        </div> -->
          </div>
          <div style="height: 10px;">

          </div>

        </div>
      </div>

      <!-- <Tabs size="small" v-model="tab_index" v-if="total_show">
        <TabPane
          v-for="(item, i) in workbench_total_list"
          :key="i"
          :label="item.name"
          :name="String(i)"
        >
          <div class="child_btn">
            <div
              v-for="(item2, i2) in workbench_total_list[i]['child']"
              :key="i2"
              class="menu_btn"
              @click="click_btn(item2)"
            >
              <div class="menu_icon_box" :style="'background:' + item2.icon_bg">
                <span
                  :class="'menu_icon iconfont ' + item2.icon"
                  :style="'font-size:' + item2.icon_size + 'px;'"
                ></span>
              </div>
              <div class="menu_btn_name">
                {{ item2.name }}
              </div>
              <span
                v-if="!item2.func_auth_status"
                class="iconfont iconlock_fill func_lock"
              ></span>
              <div v-if="is_super_admin == 1" class="remove_btn">
                <Icon
                  type="ios-add-circle-outline"
                  @click.stop="add_menu(item2)"
                  class="add_menu_icon"
                />
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs> -->
    </div>

    <!-- <Modal
      v-model="group_show"
      :footer-hide="true"
      :mask-closable="false"
      :closable="false"
      width="580"
      title="工作台模板选择"
    >
      <div class="group_editor_txt">
        检测您未选择工作台模板，请选择合适的模板进行使用，
        <br />
        选择后右上角也可随时修改,请放心选择。
      </div>
      <div class="group_select_btn_div">
        <Button
          class="group_select_btn"
          @click="click_group_btn(item)"
          v-for="(item, i) in group_list"
          :key="i"
          >{{ item.name }}</Button
        >
      </div>
    </Modal> -->

    <Modal v-model="bind_show" :footer-hide="true" :closable="bind_weixin_mp || bind_dingding" :mask-closable="false">
      <div class="bind_show_title">大象系统-帐户重要通知</div>
      <div class="alert_div">
        <Alert show-icon type="error">
          <template #icon>
            <Icon type="ios-bulb-outline" color="#0466dd"></Icon>
          </template>
          <template #desc>
            您当前帐号还未绑定

            <span class="tobind_prv" v-if="!bind_weixin_mp">【<span class="iconfont iconweixin"></span> 微信】</span>

            <span class="tobind_prv" v-if="!bind_dingding">【<span
                class="iconfont icondingding"></span>钉钉】</span>，消息接收将受到影响，请前往绑定！

            <span class="tobind" @click="to_user_info_page">点击去绑定>></span>
          </template>
        </Alert>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "workbench",
  data() {
    return {
      my_workbench_list: [],

      workbench_total_list: [],
      tab_index: "0",
      group_id: "",
      group_list: [],
      // group_show: false,

      is_super_admin: 0,
      total_show: true,

      // 绑定
      bind_show: false,
      bind_weixin_mp: true,
      bind_dingding: true,

      //
      role_id: "",
      role_data_list: [],
      total_menu_loading: false,

      //通告栏
      notifications: [],
      currentNotificationIndex: 0,
      notification_timer: null,


    };
  },

  created() {
    this.startScrolling();
  },
  destroyed() {
    clearInterval(this.notification_timer);
  },

  mounted() {
    this.get_menu_data();
    this.get_bind_info();
    this.get_role_list();
    this.get_my_menu_data();
    this.workbench_notification();
  },
  methods: {
    startScrolling() {
      this.notification_timer = setInterval(() => {
        if (this.notifications.length > 0) {
          if (this.currentNotificationIndex >= this.notifications.length - 1) {
            this.currentNotificationIndex = 0; // 重新开始循环
          } else {
            this.currentNotificationIndex++;
          }
        } else {
          this.currentNotificationIndex = 0;
        }
      }, 3000); // 每3秒更新一次
    },

    role_change() {
      this.get_menu_data();
      this.get_my_menu_data();
    },

    close_alert() {
      this.bind_weixin_mp = true;
      this.bind_dingding = true;
    },

    get_role_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/role_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.role_data_list = res.data.role_data_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },

    get_bind_info() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/bind_platform_info",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            console.log("1111111111111111", res);
            that.bind_dingding = res.data.bind_dingding;
            that.bind_weixin_mp = res.data.bind_weixin_mp;
            that.bind_show = false;
            if (!that.bind_dingding || !that.bind_weixin_mp) {
              that.bind_show = true;
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },
    //减少
    remove_menu(item) {
      var that = this;
      var obj = {
        group_id: this.group_id,
        func_id: item.func_id,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/group_menu_remove",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_menu_data();
            that.get_my_menu_data();
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //添加
    add_menu(item) {
      var that = this;
      var obj = {
        group_id: this.group_id,
        func_id: item.func_id,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/group_menu_add",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_menu_data();
            that.get_my_menu_data();
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    to_user_info_page() {
      this.bind_show = false;
      this.$emit("change", "to_user_info_page");
    },

    open() {
      // 获取用户信息

      this.get_menu_data();
      this.get_my_menu_data();
      this.get_role_list();
    },

    get_menu_data() {
      var that = this;
      var obj = {
        role_id: this.role_id,
        host: window.location.host,
        sys_id:that.$cookies.get("dx_cut_sys_id"),
      };
      this.total_menu_loading = true;
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/workbench_menu_v2",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.workbench_total_list = res.data.menu_data;
            that.is_super_admin = res.data.is_super_admin;
            console.log(that.is_super_admin);
            if (that.is_super_admin == 1) {
              that.$emit("change", "add_admin_btn");
            }

            that.$emit("change", "data_change");


            that.sys_type_list = res.data.sys_type_list
          } else {
          }
          that.total_menu_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    click_btn(item) {
      console.log(item);
      if (item.func_auth_status) {
        open_new_page(item.path);
        this.click_count(item);
      } else {
        this.$Notice.info({
          title: "操作提示",
          desc: "没有该应用的权限，如有疑问请联系管理员",
        });
      }
    },

    //点击计数
    click_count(item) {
      var that = this;
      var obj = {
        func_id: item.func_id,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/user_click_menu",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_my_menu_data();
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    group_change(e) {
      console.log(e);
      this.click_group_btn({ id: e });
    },

    //更新工作台
    click_group_btn(item) {
      var that = this;
      var obj = {
        group_id: item.id,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/update_workbench",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.group_show = false;
            that.get_my_menu_data();
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    workbench_notification() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/workbench_notification",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.notifications = res.data.data_list;
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_my_menu_data() {
      var that = this;
      // var obj = {
      //   group_id: this.group_id,
      //   host: window.location.host,
      // };
      // http(
      //   "post",
      //   process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/my_workbench_menu_hot",
      //   obj,
      //   true,
      //   "staff"
      // )
      //   .then((res) => {
      //     if (res.code == 0) {
      //       that.my_workbench_list = res.data.menu_data;
      //       that.group_list = res.data.group_list;
      //       that.group_id = res.data.current_group_id;
      //       that.tab_index = "0";
      //     } else {
      //       that.$Message.error(res.msg);
      //     }
      //   })
      //   .catch((res) => {
      //     console.log(res, "请求出错");
      //   });
    },

    click_shoucang(item, status) {
      var that = this;
      var obj = {
        func_id: item.func_id,
        collect_status: status,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/add_collect",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.get_menu_data();
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.quanbu_notif {
  display: flex;
  align-items: center;
  width: 100%;
}

.notification_div {
  margin-left: 10px;
  border: 2px solid transparent;
  /* 透明边框，用于占位 */
  position: relative;
  height: 25px;
  /* 这可能不是必需的，取决于您的布局 */
  overflow: hidden;
  /* 如果需要限制外部容器的高度 */
}

.notification-bar {
  width: 100%;
  font-weight: 300;
  height: 24px;
  /* 容器高度 */
  overflow: hidden;
  /* 隐藏超出部分 */
  background-color: #f4f4f4;
  border-radius: 2px;
  color: rgb(100, 100, 100);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 10px 0 5px;
}

.notification {
  padding: 20px;
  height: 50px;
  /* 通知高度 */
  transition: margin-top 0.5s ease-in-out;
  /* 使用 margin-top 而不是 transform */
  /* 其他样式，如内边距、边框等 */
}

.btn_right_icon {
  top: 0px;
  right: 2px;
  position: absolute;
  display: flex;
  align-items: center;
}

.iconshoucang {
  cursor: pointer;
  font-size: 13px;
  color: #ffbb80;
}

.iconshoucang1 {
  cursor: pointer;
  font-size: 13px;
  color: #f6f3f3;
}

.iconshoucang1:hover {
  color: #ccc;
}

.hover_collect:hover {
  cursor: pointer;
  color: red;
}

.collect_div {
  margin-right: 5px;
}

.hot_div {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 33px;
  z-index: 999;
}

.hot_txt {
  background: #ff0808;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  padding: 1px 4px;
}

.menu_hot {
  font-size: 18px;
}

.hot_div {
  animation: menu_hot2 1.2s linear infinite;
  color: #ff0808;
}

@keyframes menu_hot2 {
  0% {
    opacity: 1;
    top: -3px;
  }

  50% {
    top: 2px;
    opacity: 0.6;
  }

  100% {
    opacity: 1;
    top: -3px;
  }
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.bind_show_title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 20px;
}

.child_list {
  display: flex;
}

.child_title {
  text-align: center;
  width: 40px;
  writing-mode: vertical-rl;
  /* transform: rotate(180deg); */
  font-size: 13px;
  padding: 10px 10px 10px 10px;
  background: #0466dd;
  color: #ffffff;
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 300;
}

/deep/ .ivu-alert-with-desc.ivu-alert-with-icon {
  padding: 10px 50px 10px 65px;
}

.tobind_prv {
  margin: 0px 0px;
  color: #2487ff;
}

.tobind {
  color: #2487ff;
  cursor: pointer;
}

.tobind:hover {
  font-weight: 600;
}

.alert_div {
  padding-top: 20px;
  min-height: 150px;
}

.add_menu {
  display: none;
}

.remove_btn {
  display: none;
}

.zhedie_span {
  display: flex;
  align-items: center;
}

.zhedie_txt {
  font-size: 13px;
  font-weight: 300;
}

.zhedie {
  width: 50px;
  flex-shrink: 0;
  float: right;
  font-size: 24px;
  color: #bcbcbc;
}

.zhedie:hover {
  color: #0466dd;
  cursor: pointer;
}

.add_menu_icon {
  color: #ccc;
  font-size: 16px;
}

.add_menu_icon:hover {
  color: #0466dd;
}

.func_lock {
  position: absolute;
  right: 5px;
  top: 2px;
  font-size: 14px;
  color: #fff;
}

.group_select_btn_div {
  display: flex;
  flex-wrap: wrap;
}

.group_editor_txt {
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 1px solid #ececec;
  padding-bottom: 20px;
}

.group_select_btn {
  margin: 0 10px 5px 0;
}

.group_select {
  float: right;
  margin-bottom: 10px;
  font-weight: 400;
}

.child_btn {
  /* padding: 15px 0 10px 0; */
  display: flex;
  flex-wrap: wrap;
  border-top: 1px dashed #ececec;
}

.child_btn-1 {
  width: 100%;
  padding: 15px 0 0px 0;
  height: 75px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  border-top: 1px dashed #ececec;
}

.box_title1 {
  font-weight: 600;
}

.box_title {
  margin-bottom: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu_icon_box {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: 5px;
  position: relative;
}

.menu_icon {
  color: #fff;
}

.menu_btn_name {
  width: 120px;
  font-size: 13px;
}

.menu_btn {
  width: 150px;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #fff;
  transition: transform 0.4s ease;
  /* 设置变换效果和时长 */
  transform: translateY(0);
  position: relative;
}

.menu_btn:hover {
  cursor: pointer;
  border: 1px solid #ecf8ffcc;
  box-shadow: 0 0 5px #d9dfea;
  transform: translateY(-5px);
  /* 上移10像素 */
}

.menu_btn_my {
  width: 150px;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 10px;
  margin-right: 8px;
  margin-bottom: 5px;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #fff;
  transition: transform 0.4s ease;
  /* 设置变换效果和时长 */
  transform: translateY(0);
}

.menu_btn_my:hover {
  cursor: pointer;
  border: 1px solid #ecf8ffcc;
  box-shadow: 0 0 5px #d9dfea;
  transform: translateY(-5px);
  /* 上移10像素 */
}

.menu_btn:hover .remove_btn {
  display: block;
}

.menu_btn:hover .func_lock {
  color: #f26060;
}

.page1 {
  margin: 10px 10px 10px 10px;
  border-radius: 5px;
}

.page12 {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  height: calc(100vh - 345px);
  overflow: auto;
  position: relative;
  margin: 10px 10px 10px 10px;
}

.box_title_outer {
  padding: 0 10px;
}



.page12-1 {
  /* padding: 10px; */
  border-radius: 5px;
  position: relative;
  overflow: auto;
  margin: 10px 10px 10px 0px;
  width: calc(100vw - 170px);
  position: relative;
}

::-webkit-scrollbar {
  display: none;
}

.pagemain {
  /* width: calc(100vw - 120px); */
  /* min-width: 800px; */
  padding:10px;
  height: calc(100vh - 0px);
  overflow: auto;
  overflow-y: scroll;
  background: #ececec;
}
</style>
